import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormGroup, Validators } from '@angular/forms';
import { ShowHideTextControl } from 'projects/money-movement-ui/src/app/create-request/models/form/FormControlAlternatingTextLink';
import { createControl } from 'projects/money-movement-ui/src/app/create-request/utilities/formUtilities';
import { map, Observable, Subject, takeUntil } from 'rxjs';

@Component({
  standalone: false,
  selector: 'mm-show-hide-text-control',
  templateUrl: './show-hide-text-control.component.html',
  styleUrls: ['./show-hide-text-control.component.scss']
})
export class ShowHideTextControlComponent implements OnInit {
  @Input() parentForm!: UntypedFormGroup;
  @Input() showHideTextControlModel!: ShowHideTextControl;
  @Input() isLinkEnabled: boolean;
  @Input() hideIntermediaryAddressFields: string | null;
  @Input() hideReceivingAddressFields: string | null;
  @Input() isIntermediary: boolean;
  isText1: boolean = true;
  private destroy$ = new Subject<void>();
  @Output() isclosed = new EventEmitter<boolean>();

  constructor() { }

  ngOnInit(): void {
    createControl(this.parentForm,
      this.showHideTextControlModel.controlName,
      this.showHideTextControlModel.text1.value,
      [Validators.required], undefined);
    this.isText1 = this.isIntermediary ? this.hideIntermediaryAddressFields == "yes" : this.hideReceivingAddressFields == "yes";
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  changeShowHideTextState() {
    this.isText1 = this.isIntermediary ? this.hideIntermediaryAddressFields == "yes" : this.hideReceivingAddressFields == "yes";
    if (this.isText1) {
      this.parentForm.controls[this.showHideTextControlModel.controlName].setValue(this.showHideTextControlModel.text2.value);
      this.isText1 = false;
      this.isclosed.emit(true);
    } else {
      this.parentForm.controls[this.showHideTextControlModel.controlName].setValue(this.showHideTextControlModel.text1.value);
      this.isText1 = true;
      this.isclosed.emit(false);
    }
  }
}